import { Navigate, Outlet } from "react-router";
import { Skeleton } from "@pracownik/ui";
import { useIsAdmin } from "@/lib/admin";

export function AdminGuard() {
  const { isAdmin, isLoading } = useIsAdmin();
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Skeleton className="h-8 w-48" />
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
